var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21H7C4.79086 21 3 19.2091 3 17V11.1C3 9.73298 3.6214 8.44008 4.68886 7.5861L9.18886 3.9861C10.8323 2.6713 13.1677 2.6713 14.8111 3.9861L19.3111 7.5861C20.3786 8.44008 21 9.73298 21 11.1V13",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3871 17.3939L17.6533 18.1226C17.4151 18.2227 17.2255 18.4122 17.1253 18.6504L16.3944 20.3878C16.2304 20.7775 15.839 21.022 15.4168 20.9984C14.9945 20.9747 14.6329 20.688 14.5134 20.2824L13.0417 15.2837C12.9384 14.9326 13.0351 14.5531 13.2939 14.2943C13.5526 14.0355 13.9321 13.9387 14.2832 14.042L19.2819 15.5128C19.6876 15.6322 19.9744 15.994 19.998 16.4163C20.0216 16.8385 19.777 17.23 19.3871 17.3939Z",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceType);
export default __webpack_public_path__ + "static/media/placeType.e51a4aa30edff056228866a3aac57778.svg";
export { ForwardRef as ReactComponent };